export function calculateEWMAVolatility(
  prices: number[],
  lambda = 0.94, // RiskMetrics standard
  annualizationFactor = 365 * 24 * 60, // For minute data
): number {
  if (prices.length < 2) {
    // console.warn('Need at least 2 prices for EWMA volatility');
    return 0;
  }

  // Calculate log returns
  const returns: number[] = [];
  for (let i = 1; i < prices.length; i++) {
    returns.push(Math.log(prices[i] / prices[i - 1]));
  }

  // Initialize with first squared return
  let ewmaVariance = returns[0] * returns[0];

  // EWMA calculation: σ²(t) = λ·σ²(t-1) + (1-λ)·r²(t)
  for (let i = 1; i < returns.length; i++) {
    ewmaVariance =
      lambda * ewmaVariance + (1 - lambda) * returns[i] * returns[i];
  }

  // Annualize and return volatility (not variance)
  return Math.sqrt(ewmaVariance * annualizationFactor);
}

export function calculateVolatility(
  prices: number[],
  intervalSeconds: number,
): number {
  const intervalsPerYear = (365 * 24 * 60 * 60) / intervalSeconds;
  return calculateEWMAVolatility(prices, 0.94, intervalsPerYear);
}
